<template>
  <div class="l-modal-mask" v-if="showFilters" @click.self="$emit('hide-filters')">
    <div v-if="showFilters" class="filters-side-modal flex flex-column">
      <div @click="$emit('hide-filters')" class="pointer">
        <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
      </div>
      <div>
        <p>
          Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
        </p>
      </div>
      <div class="l-bg-white">
        <div class="row">
          <div class="col">
            <div class="row filters">
              <div class="col-12">
                <div class="select-wrap">
                  <label>Company</label>
                  <key-multiselect v-model="filters.company"
                                   :options="companies"
                                   :multiple="true"
                                   :clear-on-select="false"
                                   :hide-selected="true"
                                   :preserve-search="false"
                                   label="name"
                                   track-by="id"
                                   @input="$emit('search')"
                  >
                    <template slot="tag" slot-scope="props">
                      <div class="multiselect__tag">
                        <span>{{ props.option.name }}</span>
                        <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                      </div>
                    </template>
                  </key-multiselect>
                </div>
              </div>
              <div class="col-12">
                <div class="select-wrap">
                  <label>Carriers</label>
                  <key-multiselect v-model="filters.carrier"
                                   :options="carriers"
                                   :multiple="true"
                                   :clear-on-select="false"
                                   :hide-selected="true"
                                   :preserve-search="false"
                                   label="name"
                                   track-by="id"
                                   @input="$emit('search')"
                  >
                    <template slot="tag" slot-scope="props">
                      <div class="multiselect__tag">
                        <span>{{ props.option.name }}</span>
                        <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                      </div>
                    </template>
                  </key-multiselect>
                </div>
              </div>
              <div class="col-12">
                <div class="select-wrap">
                  <label>Created at</label>
                  <flat-pickr v-model="filters.created_at"
                              :config="config"
                              class="simple-select-input"
                              placeholder="Select Created At"
                              name="date"
                              @on-close="onCreatedAtChange"
                  />
                  <span class="position-absolute clear-date" @click="clearCreatedAtAndSearch"
                        v-if="filters.created_at"
                  >
                    <span class="mod-icon-clear" />
                    <span aria-hidden="true" class="sr-only">Clear</span>
                  </span>
                  <span class="position-absolute clear-date clear-date-transparent"
                        v-else
                  ><span class="mod-icon-rates-dark" /></span>
                </div>
              </div>
              <div v-if="$_can('tags.show')" class="col-12">
                <div class="select-wrap">
                  <label>Tags</label>
                  <key-multiselect
                    v-model="filters.tags"
                    :options="tags"
                    :multiple="true"
                    :clear-on-select="false"
                    :close-on-select="false"
                    track-by="id"
                    @input="$emit('search')"
                    label="name"
                    class="w-100"
                  >
                    <template slot="tag" slot-scope="props">
                      <span class="multiselect__tag p-0 bg-transparent">
                        <span>
                          <tag-color
                            :color="props.option.color.name"
                            :name="props.option.name"
                          />
                        </span>
                      </span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <div class="d-flex align-items-center justify-content-between">
                          <span class="option__title">
                            {{ props.option.name }}
                          </span>
                        </div>
                      </div>
                    </template>
                  </key-multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-auto">
        <div class="col">
          <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                  v-if="!clearFiltersButtonShouldBeDisabled"
          >
            Clear filters
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import TagColor from '../../settings/Tags/TagColor';

export default {
  name: 'FiltersModal',
  components: {
    flatPickr,
    TagColor,
  },
  props: {
    clearFiltersButtonShouldBeDisabled: {
      type: Boolean,
      default: false,
    },
    carriers: {
      type: Array,
      default: () => [],
    },
    companies: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => {},
    },
    showFilters: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    config: {
      dateFormat: 'm/j/Y',
      mode: 'range',
    },
  }),
  methods: {
    clearFilters() {
      this.$emit('clear-filters');
    },
    clearCreatedAtAndSearch() {
      this.filters.created_at = '';
      this.filters.createdAtStart = '';
      this.filters.createdAtEnd = '';
      this.page = 1;
      this.$emit('filter');
    },
    onCreatedAtChange(selectedDates) {
      this.filters.createdAtStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.createdAtEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.$emit('search');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/sales/FiltersModal.vue